import { useState } from "react";
import ModalBase from "./ModalBase";
import TextInput from "../forms/TextInput";
import { validateBuyerAccount } from "../../js/utils/validators";

export default function BuyerAccountModal({ isOpen, onClose, onSubmit, initialValues = {} }) {
  const linking = !initialValues.id;
  const [form, setForm] = useState({
    name: initialValues.name || "",
    email: initialValues.email || "",
    phone: initialValues.phone || "",
    password: "",
    agent: initialValues.agentName || initialValues.agent || "",
    broker: initialValues.brokerName || initialValues.broker || "",
    office: initialValues.office || "",
  });
  const [errors, setErrors] = useState({});

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  function handleSubmit(event) {
    event.preventDefault();
    const nextErrors = validateBuyerAccount(form, { linking });
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;
    onSubmit({ ...form, agentName: form.agent, brokerName: form.broker });
  }

  return (
    <ModalBase isOpen={isOpen} title={linking ? "Create Your Buyer Account" : "Buyer account"} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <TextInput label="Full Name" name="name" value={form.name} onChange={update} error={errors.name} required />
        <TextInput label="Email" name="email" type="email" value={form.email} onChange={update} error={errors.email} required />
        <TextInput label="Phone" name="phone" value={form.phone} onChange={update} error={errors.phone} />
        {linking ? (
          <>
            <TextInput label="Your agent" name="agent" value={form.agent} onChange={update} error={errors.agent} />
            <TextInput label="Your broker" name="broker" value={form.broker} onChange={update} error={errors.broker} />
            <TextInput label="Office" name="office" value={form.office} onChange={update} error={errors.office} />
          </>
        ) : null}
        <TextInput
          label="Password"
          name="password"
          type="password"
          value={form.password}
          onChange={update}
          autoComplete="new-password"
        />
        <button type="submit" className="primary-btn btn-block">
          Save & Continue
        </button>
        {linking ? (
          <p className="field-hint" style={{ textAlign: "center", marginTop: "0.75rem" }}>
            Already have an account?{" "}
            <button
              type="button"
              className="text-btn"
              onClick={() => {
                onClose();
                window.location.assign("/login");
              }}
            >
              Sign In
            </button>
          </p>
        ) : null}
      </form>
    </ModalBase>
  );
}
